import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["isOpen"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useCallback, useMemo, forwardRef, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { ToolbarEnum } from './types';
import metrics from '@/services/metrics';
import { flatObjectHash } from '@/utils/widget/hashing';
import { useToast } from '@/hooks/useToast';
import { getEditingWidgetToolbarAttr } from '@/components/Editor/hooks/useEditingAreas';
import useEditingAreasState from '@/components/Editor/hooks/useEditingAreasState';
import ToolbarMenu, { MenuItem } from '@/components/ToolbarMenu';
import { ButtonV2 as Button } from '@/components/Button';
import { Dropdown, DropdownMenu, DropdownMenuItem, DropdownOpenButton } from '@/components/lists/DropdownV2';
import ColorPicker from '@/components/Editor/Form/fields/common/ColorPicker';
import RevealPill from '@/components/Editor/Form/fields/RevealPill';
import { PaddingFields } from '@/components/Editor/Form/fields/SectionLayoutFields';
import ResizeControlsDropdown from './ResizeControls';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ViewTableIcon = function ViewTableIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3 9.4C3 7.15979 3 6.03968 3.43597 5.18404C3.81947 4.43139 4.43139 3.81947 5.18404 3.43597C6.03968 3 7.15979 3 9.4 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03968 21 7.15979 21 9.4V14.6C21 16.8402 21 17.9603 20.564 18.816C20.1805 19.5686 19.5686 20.1805 18.816 20.564C17.9603 21 16.8402 21 14.6 21H9.4C7.15979 21 6.03968 21 5.18404 20.564C4.43139 20.1805 3.81947 19.5686 3.43597 18.816C3 17.9603 3 16.8402 3 14.6V9.4Z",
      fill: "#C3C9D1"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 16L9 21H11L11 16H21V14H11V10H21V8H11L11 3H9L9 8H3V10H9V14H3V16H9Z",
      fill: "black"
    })]
  }));
};

ViewTableIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ShareIcon = function ShareIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 15.2413L3 12C3 11.4477 3.44772 11 4 11C4.55229 11 5 11.4477 5 12L5 15.2C5 16.0566 5.00078 16.6389 5.03755 17.089C5.07337 17.5274 5.1383 17.7516 5.21799 17.908C5.40973 18.2843 5.7157 18.5903 6.09202 18.782C6.24842 18.8617 6.47262 18.9266 6.91104 18.9625C7.36113 18.9992 7.94342 19 8.8 19H15.2C16.0566 19 16.6389 18.9992 17.089 18.9624C17.5274 18.9266 17.7516 18.8617 17.908 18.782C18.2843 18.5903 18.5903 18.2843 18.782 17.908C18.8617 17.7516 18.9266 17.5274 18.9625 17.089C18.9992 16.6389 19 16.0566 19 15.2L19 12C19 11.4477 19.4477 11 20 11C20.5523 11 21 11.4477 21 12V15.2411C21 16.0462 21 16.7106 20.9558 17.2518C20.9099 17.8139 20.8113 18.3306 20.564 18.816C20.1805 19.5686 19.5686 20.1805 18.816 20.564C18.3306 20.8113 17.8139 20.9099 17.2518 20.9558C16.7106 21 16.0463 21 15.2413 21H8.7587C7.95373 21 7.28937 21 6.74817 20.9558C6.18608 20.9099 5.66937 20.8113 5.18404 20.564C4.43139 20.1805 3.81947 19.5686 3.43597 18.816C3.18868 18.3306 3.09012 17.8139 3.04419 17.2518C2.99998 16.7106 2.99999 16.0463 3 15.2413Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.70711 7.70711C9.31658 8.09763 8.68342 8.09763 8.29289 7.70711C7.90237 7.31658 7.90237 6.68342 8.29289 6.29289L11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289L15.7071 6.29289C16.0976 6.68342 16.0976 7.31658 15.7071 7.70711C15.3166 8.09763 14.6834 8.09763 14.2929 7.70711L13 6.41421V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V6.41421L9.70711 7.70711Z",
      fill: "#12131A"
    })]
  }));
};

ShareIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var FloppyDiskIcon = function FloppyDiskIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.33331 11.6667C7.87308 11.6667 7.49998 12.0398 7.49998 12.5V16.6667H5.83331V12.5C5.83331 11.1193 6.9526 10 8.33331 10H11.6666C13.0474 10 14.1666 11.1193 14.1666 12.5V16.6667H12.5V12.5C12.5 12.0398 12.1269 11.6667 11.6666 11.6667H8.33331Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5 5.83331V3.33331H10.8333V5.83331C10.8333 6.29355 10.4602 6.66665 9.99998 6.66665H8.33331C7.87308 6.66665 7.49998 6.29355 7.49998 5.83331V3.33331H5.83331V5.83331C5.83331 7.21402 6.9526 8.33331 8.33331 8.33331H9.99998C11.3807 8.33331 12.5 7.21403 12.5 5.83331Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5362 4.23578C12.2708 4.17206 11.9792 4.1667 11.1242 4.1667H8.66667C7.7195 4.1667 7.05924 4.16735 6.5452 4.20935C6.04089 4.25055 5.75115 4.32736 5.53169 4.43919C5.06129 4.67887 4.67883 5.06132 4.43915 5.53173C4.32733 5.75119 4.25052 6.04093 4.20931 6.54524C4.16732 7.05927 4.16667 7.71953 4.16667 8.6667V11.3334C4.16667 12.2805 4.16732 12.9408 4.20931 13.4548C4.25052 13.9591 4.32733 14.2489 4.43915 14.4683C4.67883 14.9388 5.06129 15.3212 5.53169 15.5609C5.75115 15.6727 6.04089 15.7495 6.5452 15.7907C7.05924 15.8327 7.7195 15.8334 8.66667 15.8334H11.3333C12.2805 15.8334 12.9408 15.8327 13.4548 15.7907C13.9591 15.7495 14.2488 15.6727 14.4683 15.5609C14.9387 15.3212 15.3212 14.9388 15.5609 14.4683C15.6727 14.2489 15.7495 13.9591 15.7907 13.4548C15.8327 12.9408 15.8333 12.2805 15.8333 11.3334V8.87584C15.8333 8.02087 15.828 7.72921 15.7643 7.4638C15.703 7.20871 15.602 6.96485 15.4649 6.74117C15.3223 6.50844 15.1199 6.29841 14.5153 5.69386L14.3062 5.48472C13.7016 4.88017 13.4916 4.67772 13.2589 4.5351C13.0352 4.39803 12.7913 4.29702 12.5362 4.23578ZM11.2192 2.50002C11.9431 2.49981 12.4442 2.49966 12.9253 2.61516C13.3505 2.71723 13.7569 2.88558 14.1297 3.11403C14.5515 3.37254 14.9058 3.72699 15.4175 4.23904C15.4396 4.26114 15.462 4.28353 15.4847 4.30621L15.6938 4.51535C15.7165 4.53803 15.7389 4.5604 15.761 4.58248C16.273 5.09424 16.6275 5.44849 16.886 5.87034C17.1145 6.24314 17.2828 6.64957 17.3849 7.07473C17.5004 7.55581 17.5002 8.05693 17.5 8.78089C17.5 8.81212 17.5 8.84377 17.5 8.87584V11.3691C17.5 12.2722 17.5 13.0007 17.4518 13.5906C17.4022 14.1979 17.2973 14.7314 17.0459 15.225C16.6464 16.009 16.009 16.6464 15.225 17.0459C14.7314 17.2974 14.1979 17.4022 13.5905 17.4519C13.0006 17.5001 12.2722 17.5 11.369 17.5H8.63097C7.72783 17.5 6.99937 17.5001 6.40948 17.4519C5.80211 17.4022 5.26862 17.2974 4.77504 17.0459C3.99103 16.6464 3.35361 16.009 2.95414 15.225C2.70265 14.7314 2.59781 14.1979 2.54818 13.5906C2.49999 13.0007 2.49999 12.2722 2.5 11.369V8.63103C2.49999 7.72788 2.49999 6.99941 2.54818 6.40952C2.59781 5.80214 2.70265 5.26865 2.95414 4.77508C3.35361 3.99107 3.99103 3.35365 4.77504 2.95418C5.26862 2.70269 5.80211 2.59784 6.40948 2.54822C6.99938 2.50002 7.72784 2.50003 8.631 2.50004L11.1242 2.50004C11.1563 2.50004 11.1879 2.50003 11.2192 2.50002Z",
      fill: "black"
    })]
  }));
};

FloppyDiskIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ThemesIcon = function ThemesIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M7.5 9.16667C7.5 8.24619 8.24619 7.5 9.16667 7.5H15.8333C16.7538 7.5 17.5 8.24619 17.5 9.16667V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H9.16667C8.24619 17.5 7.5 16.7538 7.5 15.8333V9.16667Z",
      fill: "#C3C9D1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.5 7.5C12.5 10.2614 10.2614 12.5 7.5 12.5C4.73858 12.5 2.5 10.2614 2.5 7.5C2.5 4.73858 4.73858 2.5 7.5 2.5C10.2614 2.5 12.5 4.73858 12.5 7.5Z",
      fill: "#12131A"
    })]
  }));
};

ThemesIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ImageIcon = function ImageIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3 9.4C3 7.15979 3 6.03968 3.43597 5.18404C3.81947 4.43139 4.43139 3.81947 5.18404 3.43597C6.03968 3 7.15979 3 9.4 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03968 21 7.15979 21 9.4V14.6C21 16.8402 21 17.9603 20.564 18.816C20.1805 19.5686 19.5686 20.1805 18.816 20.564C17.9603 21 16.8402 21 14.6 21H9.4C7.15979 21 6.03968 21 5.18404 20.564C4.43139 20.1805 3.81947 19.5686 3.43597 18.816C3 17.9603 3 16.8402 3 14.6V9.4Z",
      fill: "#12131A",
      fillOpacity: "0.25"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9 11C10.1046 11 11 10.1046 11 9C11 7.89543 10.1046 7 9 7C7.89543 7 7 7.89543 7 9C7 10.1046 7.89543 11 9 11Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3 15.0874C3.00116 16.0587 3.0095 16.799 3.06965 17.3958L6.40166 15.3355C6.86668 15.048 6.92276 15.0259 6.96158 15.0159C7.0268 14.9991 7.09473 14.9957 7.16131 15.0058C7.20094 15.0119 7.25896 15.0282 7.75057 15.2674L8.27892 15.5246L8.36868 15.5684C8.7431 15.7515 9.11943 15.9356 9.52751 15.9894C9.88347 16.0363 10.2454 16.006 10.5886 15.9005C10.982 15.7796 11.3225 15.5355 11.6612 15.2926L11.7424 15.2344L14.2481 13.4454C14.7946 13.0552 14.864 13.0245 14.9095 13.0124C14.987 12.9917 15.0684 12.99 15.1467 13.0073C15.1926 13.0175 15.2633 13.0452 15.8259 13.4119L20.9737 16.7665C20.9998 16.1817 20.9998 15.4766 20.9998 14.5999V14.3963L16.9179 11.7363L16.822 11.6736C16.4264 11.4145 16.0294 11.1545 15.5798 11.0548C15.1881 10.9679 14.7814 10.9766 14.3938 11.08C13.9489 11.1988 13.5633 11.4754 13.179 11.751L13.0859 11.8177L10.5802 13.6068C10.1011 13.9489 10.0417 13.9763 10.001 13.9888C9.93238 14.0099 9.86001 14.0159 9.78881 14.0065C9.74664 14.001 9.68349 13.9838 9.15411 13.7262L8.62575 13.4691L8.54259 13.4285C8.19396 13.258 7.84332 13.0866 7.46198 13.0286C7.1291 12.9779 6.78942 12.9951 6.46333 13.079C6.08976 13.1751 5.75817 13.381 5.42848 13.5857L5.34983 13.6345L3 15.0874Z",
      fill: "#12131A"
    })]
  }));
};

ImageIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var LineChartIcon = function LineChartIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_7784_1428)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M0 15.3351V12.9789L7.97003 10.3222C8.57498 10.1206 9.22489 10.0956 9.84353 10.2503L13.0511 11.0522C13.2574 11.1037 13.474 11.0954 13.6756 11.0282L22.3529 8.13574V10.4919L14.3825 13.1488C13.7776 13.3504 13.1276 13.3754 12.509 13.2207L9.30139 12.4188C9.09518 12.3673 8.87854 12.3756 8.67689 12.4428L0 15.3351Z",
        fill: "#8C8C8C"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.1176 4.47294C20.1176 3.57415 19.1106 3.04301 18.3688 3.55056L14.8723 5.9431C14.0811 6.48454 13.0958 6.66133 12.1657 6.42879L9.54144 5.77273C9.26186 5.70283 8.96608 5.74363 8.71587 5.88662L2.79843 9.26801C2.4502 9.467 2.23529 9.83732 2.23529 10.2384V15.6471C2.23529 16.2643 2.73568 16.7647 3.35294 16.7647H19C19.6173 16.7647 20.1176 16.2643 20.1176 15.6471V4.47294ZM17.1065 1.7058C19.3318 0.18313 22.3529 1.77658 22.3529 4.47294V15.6471C22.3529 17.4989 20.8518 19 19 19H3.35294C1.50116 19 0 17.4989 0 15.6471V10.2384C0 9.03517 0.644724 7.9242 1.68942 7.32723L7.60685 3.94584C8.3575 3.51689 9.24483 3.39449 10.0836 3.60417L12.7078 4.26023C13.0179 4.33775 13.3463 4.27882 13.61 4.09834L17.1065 1.7058Z",
        fill: "#12131A"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_7784_1428",
        children: /*#__PURE__*/_jsx("rect", {
          width: "22.3529",
          height: "19",
          fill: "white"
        })
      })
    })]
  }));
};

LineChartIcon.defaultProps = {
  width: "23",
  height: "19",
  viewBox: "0 0 23 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var DataIcon = function DataIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 16V20H11V16H20V14H11L11 10H20V8H11V4H9V8H4V10H9L9 14H4V16H9Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.3572 3H13.6428C14.7266 2.99999 15.6007 2.99998 16.3086 3.05782C17.0375 3.11737 17.6777 3.24318 18.27 3.54497C19.2108 4.02433 19.9757 4.78924 20.455 5.73005C20.7568 6.32234 20.8826 6.96253 20.9422 7.69138C21 8.39925 21 9.27339 21 10.3572V13.6428C21 14.7266 21 15.6008 20.9422 16.3086C20.8826 17.0375 20.7568 17.6777 20.455 18.27C19.9757 19.2108 19.2108 19.9757 18.27 20.455C17.6777 20.7568 17.0375 20.8826 16.3086 20.9422C15.6008 21 14.7266 21 13.6428 21H10.3572C9.27339 21 8.39925 21 7.69138 20.9422C6.96253 20.8826 6.32234 20.7568 5.73005 20.455C4.78924 19.9757 4.02433 19.2108 3.54497 18.27C3.24318 17.6777 3.11737 17.0375 3.05782 16.3086C2.99998 15.6007 2.99999 14.7266 3 13.6428V10.3572C2.99999 9.27341 2.99998 8.39926 3.05782 7.69138C3.11737 6.96253 3.24318 6.32234 3.54497 5.73005C4.02433 4.78924 4.78924 4.02433 5.73005 3.54497C6.32234 3.24318 6.96253 3.11737 7.69138 3.05782C8.39926 2.99998 9.27341 2.99999 10.3572 3ZM7.85424 5.05118C7.24907 5.10062 6.90138 5.19279 6.63803 5.32698C6.07354 5.6146 5.6146 6.07354 5.32698 6.63803C5.19279 6.90138 5.10062 7.24907 5.05118 7.85424C5.00078 8.47108 5 9.26339 5 10.4V13.6C5 14.7366 5.00078 15.5289 5.05118 16.1458C5.10062 16.7509 5.19279 17.0986 5.32698 17.362C5.6146 17.9265 6.07354 18.3854 6.63803 18.673C6.90138 18.8072 7.24907 18.8994 7.85424 18.9488C8.47108 18.9992 9.26339 19 10.4 19H13.6C14.7366 19 15.5289 18.9992 16.1458 18.9488C16.7509 18.8994 17.0986 18.8072 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C18.8072 17.0986 18.8994 16.7509 18.9488 16.1458C18.9992 15.5289 19 14.7366 19 13.6V10.4C19 9.26339 18.9992 8.47108 18.9488 7.85424C18.8994 7.24907 18.8072 6.90138 18.673 6.63803C18.3854 6.07354 17.9265 5.6146 17.362 5.32698C17.0986 5.19279 16.7509 5.10062 16.1458 5.05118C15.5289 5.00078 14.7366 5 13.6 5H10.4C9.26339 5 8.47108 5.00078 7.85424 5.05118Z",
      fill: "black"
    })]
  }));
};

DataIcon.defaultProps = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var AiIcon = function AiIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M17 8C17.5523 8 18 7.55228 18 7V6H19C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4H18V3C18 2.44772 17.5523 2 17 2C16.4477 2 16 2.44772 16 3V4L15 4C14.4477 4 14 4.44772 14 5C14 5.55228 14.4477 6 15 6H16L16 7C16 7.55228 16.4477 8 17 8Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17 22C17.5523 22 18 21.5523 18 21V20H19C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18H18V17C18 16.4477 17.5523 16 17 16C16.4477 16 16 16.4477 16 17V18H15C14.4477 18 14 18.4477 14 19C14 19.5523 14.4477 20 15 20H16L16 21C16 21.5523 16.4477 22 17 22Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.4065 7.19789C11.1514 5.59802 8.84879 5.59802 8.59365 7.19789C8.31512 8.9445 6.94543 10.3143 5.19888 10.5928C3.59909 10.848 3.59905 13.1504 5.19888 13.4056C6.94542 13.6842 8.31512 15.0539 8.59365 16.8006C8.84878 18.4004 11.1514 18.4004 11.4065 16.8006C11.6851 15.0539 13.0547 13.6842 14.8013 13.4056C16.4011 13.1504 16.4011 10.848 14.8013 10.5928C13.0547 10.3143 11.6851 8.9445 11.4065 7.19789Z",
      fill: "#C3C9D1"
    })]
  }));
};

AiIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const MENU_ITEMS = [{
  icon: /*#__PURE__*/_jsx(ViewTableIcon, {}),
  title: 'Data',
  id: ToolbarEnum.DATA
}, {
  icon: /*#__PURE__*/_jsx(ThemesIcon, {}),
  title: 'Themes',
  id: ToolbarEnum.THEME
}];
const AI_GENERATION_ERROR_TIMEOUT = 3000;
const AI_GENERATION_ERROR_MESSAGES = {
  data_generate: 'Failed to generate AI data. Please try again later.',
  chart_suggest: 'Failed to suggest AI chart. Please try again later.'
};
const WidgetPreviewToolbar = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    isSmallContainer = false,
    isAiExperiment = false,
    hasChanges = false,
    widget,
    previewGroups,
    previewResolution,
    activePreviewGroup,
    updatePreviewResolution,
    updateActivePreviewGroup,
    textOverrides = {},
    aspectRatio,
    adjustAspectRatio,
    defaultAspectRatio,
    onWidgetUpdate,
    onSave,
    onShare,
    onEditData,
    onEditTheme
  } = _ref;
  const nameSpace = 'widget-preview-toolbar';
  const {
    0: activeAiGeneration,
    1: setActiveAiGeneration
  } = useState(null);
  const {
    addToast: sendNotification
  } = useToast();
  const {
    activeSectionId
  } = useEditingAreasState();
  const widgetSectionsHash = activeSectionId ? flatObjectHash((widget === null || widget === void 0 ? void 0 : widget.sections) || {}) : '';
  const activeSection = useMemo(() => {
    if (!activeSectionId || !widget) return null;
    return (widget.sections || {})[activeSectionId]; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [widgetSectionsHash, activeSectionId]);
  const handleAiGenerate = useCallback(type => {
    metrics.sendEvent(`exp_ai_${type}`, {});
    setActiveAiGeneration(type);
    setTimeout(() => {
      sendNotification({
        type: 'error',
        description: AI_GENERATION_ERROR_MESSAGES[type]
      });
      setActiveAiGeneration(null);
    }, AI_GENERATION_ERROR_TIMEOUT);
  }, [sendNotification]);
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: clsx(styles.container, {
      [styles['container--isSmall']]: isSmallContainer,
      [styles['container--compact']]: isAiExperiment
    }),
    [getEditingWidgetToolbarAttr()]: (widget === null || widget === void 0 ? void 0 : widget.id) || '',
    children: [/*#__PURE__*/_jsxs(ToolbarMenu, {
      classNames: {
        menuItemIcon: styles.menuItemIcon,
        menuItemTitle: styles.menuItemTitle
      },
      direction: 'horizontal',
      items: MENU_ITEMS,
      hiddenItems: {
        [ToolbarEnum.DATA]: isSmallContainer || isAiExperiment,
        [ToolbarEnum.THEME]: isSmallContainer
      },
      onChange: item => {
        // map selected item to callback
        const cb = {
          [ToolbarEnum.DATA]: onEditData,
          [ToolbarEnum.THEME]: onEditTheme
        }[item]; // call callback if exists

        cb && cb();
      },
      children: [/*#__PURE__*/_jsx(ResizeControlsDropdown, {
        previewGroups: previewGroups,
        previewResolution: previewResolution,
        activePreviewGroup: activePreviewGroup,
        aspectRatio: aspectRatio,
        defaultAspectRatio: defaultAspectRatio,
        adjustAspectRatio: adjustAspectRatio,
        updatePreviewResolution: updatePreviewResolution,
        updateActivePreviewGroup: updateActivePreviewGroup
      }), activeSection ? /*#__PURE__*/_jsx(CanvasEditingFields, {
        nameSpace: nameSpace,
        sectionId: activeSectionId,
        section: activeSection,
        widgetId: (widget === null || widget === void 0 ? void 0 : widget.id) || '',
        label: textOverrides.canvasLabel,
        onWidgetUpdate: onWidgetUpdate
      }) : null, isAiExperiment ? /*#__PURE__*/_jsxs(Dropdown, {
        children: [/*#__PURE__*/_jsx(DropdownOpenButton, {
          Component: AiGenerateButton
        }), /*#__PURE__*/_jsxs(DropdownMenu, {
          children: [/*#__PURE__*/_jsx(DropdownMenuItem, {
            leftIcon: activeAiGeneration === 'data_generate' ? /*#__PURE__*/_jsx(CircularProgress, {
              size: 20,
              color: "inherit"
            }) : /*#__PURE__*/_jsx(DataIcon, {}),
            text: "AI Data Generator",
            disabled: Boolean(activeAiGeneration),
            onClick: () => handleAiGenerate('data_generate')
          }), /*#__PURE__*/_jsx(DropdownMenuItem, {
            leftIcon: activeAiGeneration === 'chart_suggest' ? /*#__PURE__*/_jsx(CircularProgress, {
              size: 20,
              color: "inherit"
            }) : /*#__PURE__*/_jsx(LineChartIcon, {}),
            text: "AI Chart Suggest",
            disabled: Boolean(activeAiGeneration),
            onClick: () => handleAiGenerate('chart_suggest')
          })]
        })]
      }) : null]
    }), onSave ? /*#__PURE__*/_jsx(Button, {
      type: "button",
      size: "medium",
      rightIcon: /*#__PURE__*/_jsx(FloppyDiskIcon, {}),
      className: styles.primaryButton,
      disabled: !hasChanges,
      onClick: onSave,
      children: "Save"
    }) : null, onShare ? /*#__PURE__*/_jsx(Button, {
      type: "button",
      size: "medium",
      rightIcon: /*#__PURE__*/_jsx(ShareIcon, {}),
      className: styles.primaryButton,
      onClick: onShare,
      children: "Share"
    }) : null]
  });
});
WidgetPreviewToolbar.displayName = 'WidgetPreviewToolbar'; // Canvas Editing Fields

const CanvasEditingFields = _ref2 => {
  var _section$config, _section$config$style;

  let {
    nameSpace,
    label = 'Canvas',
    section,
    sectionId,
    widgetId,
    onWidgetUpdate
  } = _ref2;
  const backgroundColorId = `${nameSpace}-backgroundColor`;
  const handleActiveSectionChange = useCallback((target, update) => {
    if (!sectionId || typeof onWidgetUpdate !== 'function') return;
    return onWidgetUpdate(`sections.${sectionId}.config${target ? '.' : ''}${target}`, update);
  }, [onWidgetUpdate, sectionId]);
  return /*#__PURE__*/_jsxs(RevealPill, {
    label: label,
    classNames: {
      container: styles.revealPillContainer
    },
    OpenButton: CanvasOpenButton,
    children: [/*#__PURE__*/_jsx(PaddingFields, {
      section: section,
      sectionId: sectionId,
      widgetId: widgetId,
      onChange: padding => handleActiveSectionChange('styles', padding)
    }), /*#__PURE__*/_jsx(ColorPicker, {
      id: backgroundColorId,
      label: "Background Color",
      caption: "Optional background color for the section",
      defaultValue: (_section$config = section.config) === null || _section$config === void 0 ? void 0 : (_section$config$style = _section$config.styles) === null || _section$config$style === void 0 ? void 0 : _section$config$style.backgroundColor,
      onChange: color => handleActiveSectionChange('styles', {
        backgroundColor: typeof color === 'string' ? color : null
      })
    }, backgroundColorId)]
  });
};

const CanvasOpenButton = _ref3 => {
  let {
    isOpen,
    label,
    setReference,
    getReferenceProps
  } = _ref3;
  return /*#__PURE__*/_jsx(MenuItem, _objectSpread({
    id: ToolbarEnum.CANVAS,
    ref: setReference,
    title: label,
    icon: /*#__PURE__*/_jsx(ImageIcon, {}),
    active: isOpen,
    classNames: {
      menuItemIcon: styles.menuItemIcon,
      menuItemTitle: styles.menuItemTitle
    }
  }, getReferenceProps()));
}; // AI Generate Button


const AiGenerateButton = /*#__PURE__*/forwardRef((_ref4, forwardedRef) => {
  let {
    isOpen
  } = _ref4,
      props = _objectWithoutProperties(_ref4, _excluded);

  return /*#__PURE__*/_jsx(MenuItem, _objectSpread({
    id: ToolbarEnum.AI,
    title: "AI",
    icon: /*#__PURE__*/_jsx(AiIcon, {}),
    active: isOpen,
    ref: forwardedRef,
    classNames: {
      menuItem: styles.dropdownButton,
      menuItemActive: styles['dropdownButton--active'],
      menuItemIcon: styles.menuItemIcon,
      menuItemTitle: styles.menuItemTitle
    }
  }, props));
});
AiGenerateButton.displayName = 'AiGenerateButton';
export default WidgetPreviewToolbar;